function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var PopupLessonMainTemplate = require('./lesson-main.template');
var PopupLessonRightTemplate = require('./lesson-right.template');
var WordTemplate = require('./word.template');
var QuestionTemplate = require('./question.template');
var SentenceTemplate = require('./sentence.template');
var SaitoLoader = require('./../../../lib/saito/ui/saito-loader/saito-loader');
var PopupLesson = /*#__PURE__*/function () {
  function PopupLesson(app, mod) {
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.popup-lesson';
    _classCallCheck(this, PopupLesson);
    this.app = app;
    this.mod = mod;
    this.container = container;
    this.name = 'PopupLesson';
    this.loader = new SaitoLoader(this.app, this.mod, '.popup-content');
  }
  return _createClass(PopupLesson, [{
    key: "render",
    value: function render() {
      var _this = this;
      var lesson_id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      //
      // get our content
      //
      this.mod.lesson = this.mod.returnLesson(lesson_id);

      //
      // lesson content
      //
      if (!document.querySelector('.lesson-container')) {
        this.app.browser.addElementToSelector(PopupLessonMainTemplate(this.mod.lesson, this.mod), '.saito-main');
        this.app.browser.addElementToSelector(PopupLessonRightTemplate(this.mod.lesson, this.mod), '.saito-sidebar.right');
      } else {
        this.app.browser.replaceElementBySelector(PopupLessonMainTemplate(this.mod.lesson), '.lesson-container');
      }

      //
      // sentences
      //
      this.mod.loadLessonSentences(this.mod.lesson, function () {
        if (_this.mod.lesson.sentences) {
          var html = '<div class="lesson-section header">transcript</div>';
          html += '<table style="width:100%;max-width:1400px;">';
          for (var i = 0; i < _this.mod.lesson.sentences.length; i++) {
            html += SentenceTemplate(_this.mod.lesson, _this.mod.lesson.sentences[i], _this.mod);
          }
          html += '</table>';
          _this.app.browser.addElementToSelector(html, '.lesson-section.transcript');
        }

        //
        // words
        //
        _this.mod.loadLessonWords(_this.mod.lesson, function () {
          if (_this.mod.lesson.words) {
            var _html = '<div class="lesson-section header">vocabulary</div>';
            _html += '<table style="width:100%;max-width:1400px;">';
            for (var _i = 0; _i < _this.mod.lesson.words.length; _i++) {
              _html += WordTemplate(_this.mod.lesson, _this.mod.lesson.words[_i], _this.mod);
            }
            _html += '</table>';
            _this.app.browser.addElementToSelector(_html, '.lesson-section.vocabulary');
          }

          //
          // questions
          //
          /****
          this.mod.loadLessonQuestions(this.mod.lesson, () => {
          if (this.mod.lesson.questions) {
          let html = '<div class="lesson-section header">comprehension:</div>';
          html += '<table style="width:100%;max-width:1400px;">';
          for (let i = 0; i < this.mod.lesson.questions.length; i++) {
          html += QuestionTemplate(this.mod.lesson, this.mod.lesson.questions[i]);
          }
          html += '</table>';
          this.app.browser.addElementToSelector(html, '.lesson-section.questions');
          }
          }); // questions
          ****/
        }); // words
      }); // sentences

      //

      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {}
  }]);
}();
module.exports = PopupLesson;